import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './config/i18n';
import { Client as Styletron } from 'styletron-engine-atomic';
import { Provider as StyletronProvider } from 'styletron-react';
import { BaseProvider } from 'baseui';
import './index.css';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/pl';
import { setLocale } from 'yup';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { renderer } from './shared/swalConfigured';
import { ThemeSwitchProvider } from './shared/themes/ThemeSwitchContext';
import { Theme } from 'baseui/theme';
import { configure, Form, List, getConfig } from "myforms"
import { StyleCompat } from './components/StyleCompat/StyleCompat';

//@ts-ignore
window.AppStore = null
setLocale({
    mixed: {
        required: 'pole jest wymagane',
        // default: 'dfs'
    },
    string: {
        min: (params) => `minimalna liczba znaków w polu to ${params.min}`,
        max: (params) => `maksymalna liczba znaków w polu to ${params.max}`,
        email: `pole musi być poprawnym adresem email`,
    }
});

const engine = new Styletron({prefix: "x"});

dayjs.locale('pl');
dayjs.extend(relativeTime);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);

renderer(engine)

const toCamelCase = ([key, value]: [string, any]): [string, any] =>  [key.split(".").map(v => v.replace(/^./, (m) => m.toLowerCase())).join("."), value]

interface IErrorParser {
    form?: Form
    errors: any
    handler?: (errorEntries: [string, any][]) => void

}

export function errorParser ({ form, errors, handler }: IErrorParser) {
    let errorEntries: [string, any][] = [];
    if(errors?.status >= 500)
        errorEntries = [["", "Wystąpił błąd serwera"]]
    if(errors?.status >= 400 && errors?.status < 500) {
        if(errors?.detail)
            errorEntries = [["", errors.detail]]
        else
            errorEntries = Object.entries(errors?.errors || {}).map(toCamelCase)
    }
    if(form) {
        errorEntries.forEach(([key, value]) => {
            if(Array.isArray(value)) {
                value.forEach(v => {
                    form.addError(key, v)
                })
            } else {
                form.addError(key, value)
            }
        })
    } else if (handler) {
        handler(errorEntries)
    }
}
configure({
    Request: {
        errorParser: errorParser
    }
})
const AppWrap = () => {
    return (
        <React.StrictMode>
            <StyletronProvider value={engine}>
                <ThemeSwitchProvider 
                    render={(themee: Theme) => 
                        <BaseProvider theme={themee} zIndex={1}>
                            <StyleCompat />
                            <App />
                        </BaseProvider>} />
            </StyletronProvider>
        </React.StrictMode>
    )
}
ReactDOM.render(
    <AppWrap />,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
